import { message, Spin } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { RegisterVerifyEmail } from '../../api/Verfiy';
import { useEffect } from 'react';

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RegisterVerify = (props) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const Verfiy = async () => {
    setLoading(true);
    try {
      const key = location.search.split('?verification_key=')[1];
      const { code } = await RegisterVerifyEmail({ verification_key: key });
      if (code === '10000') {
        message.success('Verification succeeded');
        setLoading(false);
        navigate('/login');
      } else {
        setLoading(false);
        navigate('/');
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    Verfiy();
  }, []);

  return (
    <PageContainer>
      <Spin spinning={loading}></Spin>
    </PageContainer>
  );
};

export default RegisterVerify;
